import React, { FC, useState } from "react";
import ImageSprite from "../ImageSprite/ImageSprite";
import SearchBarSelectSprite from "./Img/SearchBarSelectSprite.svg";
import "./ButtonArrow.scss";

interface ButtonArrowProps {
    onClick: () => void;
    state?: boolean | undefined;
    text: string;
}

const ButtonArrow: FC<ButtonArrowProps> = ({ onClick, text, state }) => {
    return (
        <button
            className={`button_arrow ${
                typeof state === "boolean" && state === true
                    ? "button_arrow__down"
                    : ""
            } ${
                typeof state === "boolean" && state === false
                    ? "button_arrow__up"
                    : ""
            }`}
            type="button"
            onClick={onClick}
        >
            <span>{text}</span>
            <ImageSprite iconSprite={`${SearchBarSelectSprite}#arrow`} />
        </button>
    );
};

export default React.memo(ButtonArrow);
